import React from 'react';
import { Select } from 'antd';

interface PosItemSortSelectorProps {
  value: 'rank' | 'mostPopular';
  onChange: (value: 'rank' | 'mostPopular') => void;
  style?: React.CSSProperties;
}

/**
 * Component for selecting POS item sort type
 */
const PosItemSortSelector: React.FC<PosItemSortSelectorProps> = ({ value, onChange, style }) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      style={style || { width: '150px' }}
    >
      <Select.Option value="mostPopular">Most Popular</Select.Option>
      <Select.Option value="rank">Rank</Select.Option>
    </Select>
  );
};

export default PosItemSortSelector;

